import { getEnvironmentConfig, getEnvVariable } from '../configHelper.js';
import { Brands } from '@framework/brands';
import { getCleverpushChannelsForBrand } from './cleverpush.config.js';
const definition = {
    base: {
        cleverpushUrl: 'https://api.cleverpush.com',
        brandConfig: {
            ...(getEnvVariable('CLEVERPUSH_API_KEY_FOCUS')
                ? {
                    focus: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_FOCUS') || '',
                        recipientsSource: 'topics',
                        cleverpushAndroidCategoryIdForNews: 'dEDFJdjedYeEfPN7A', // News Category ID for Android
                        cleverpushAndroidCategoryIdForBreakingNews: 'nWshXMujnzbBkcKuL', // Breaking News Category ID for Android
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.FOCUS),
                        cleverpushRecipientBlacklist: ['TCNLzxNAcvQEJgMzJ'],
                        breakingNewsConfig: {
                            targetRecipients: ['RgeMGpJ52MnKQd8PY'],
                        },
                    },
                }
                : {}),
            ...(getEnvVariable('CLEVERPUSH_API_KEY_BUNTE')
                ? {
                    bunte: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_BUNTE') || '',
                        recipientsSource: 'tags',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.BUNTE),
                        breakingNewsConfig: {
                            targetRecipients: ['kg4YKoxZ7qrR37veK'],
                        },
                    },
                }
                : {}),
            ...(getEnvVariable('CLEVERPUSH_API_KEY_FITFORFUN')
                ? {
                    fitforfun: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_FITFORFUN') || '',
                        recipientsSource: 'segments',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.FITFORFUN),
                        cleverpushRecipientWhitelist: ['Fpi8ohaQNCH7eSHC2'],
                    },
                }
                : {}),
            ...(getEnvVariable('CLEVERPUSH_API_KEY_FINANZEN100')
                ? {
                    finanzen100: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_FINANZEN100') || '',
                        recipientsSource: 'topics',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.FINANZEN100),
                        cleverpushRecipientWhitelist: ['JTRPSTupLh5rjR52m'], //F100_Top_News - Test channel
                    },
                }
                : {}),
        },
        recipientsCacheDuration: 180000,
        channelsCacheDuration: 1800000,
    },
    production: {
        brandConfig: {
            ...(getEnvVariable('CLEVERPUSH_API_KEY_FOCUS')
                ? {
                    focus: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_FOCUS') || '',
                        recipientsSource: 'topics',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.FOCUS),
                        cleverpushAndroidCategoryIdForNews: 'n4LJiAC854mPRNy5m', // News Category ID for Android
                        cleverpushAndroidCategoryIdForBreakingNews: 'u7cLHfB5hxD3g2m7D', // Breaking News Category ID for Android
                        cleverpushRecipientBlacklist: ['muWcihzspgb52EpvT'], //Filtering out Sportlive - PRODUCTION ID
                        breakingNewsConfig: {
                            cleverpushChannelWhitelist: ['6ST4phB33NWhSfWrC', 'tpt96Yabt79qgxJYK'], //WEB and APP channel - PRODUCTION ID
                            targetRecipients: ['eeXC9sCuvYmN2L4mm'], //Breaking news - PRODUCTION ID
                        },
                    },
                }
                : {}),
            ...(getEnvVariable('CLEVERPUSH_API_KEY_BUNTE')
                ? {
                    bunte: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_BUNTE') || '',
                        recipientsSource: 'tags',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.BUNTE),
                        cleverpushRecipientWhitelist: ['e2uJtDG4xoJ2LoRZC', 'CBcmm9oBmWw7cTBv4'], //Breaking news and Royals - PRODUCTION IDs
                        breakingNewsConfig: {
                            cleverpushChannelWhitelist: ['JEmqXMZbDqfokooJX', 'DQcMnJ36q2LZTjeAM', 'NQMurDdbzBCpdtHvA'], // Two APP channels and Web - PRODUCTION ID
                            targetRecipients: ['e2uJtDG4xoJ2LoRZC'], //Breaking news - PRODUCTION IDs
                        },
                    },
                }
                : {}),
            ...(getEnvVariable('CLEVERPUSH_API_KEY_FITFORFUN')
                ? {
                    fitforfun: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_FITFORFUN') || '',
                        recipientsSource: 'segments',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.FITFORFUN),
                        cleverpushRecipientWhitelist: ['Fpi8ohaQNCH7eSHC2'],
                    },
                }
                : {}),
            ...(getEnvVariable('CLEVERPUSH_API_KEY_FINANZEN100')
                ? {
                    finanzen100: {
                        authorizationKey: getEnvVariable('CLEVERPUSH_API_KEY_FINANZEN100') || '',
                        recipientsSource: 'topics',
                        cleverpushChannelWhitelist: getCleverpushChannelsForBrand(Brands.FINANZEN100),
                        cleverpushRecipientWhitelist: ['2baz9BCqdeJcjXjF6'], //F100_Top_News - Production channel
                    },
                }
                : {}),
        },
    },
};
export const articlePushConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=article-push.config.js.map